/**
 * Meaningful click = navigation or primary action — not focus, toggle, or typing (E-01, E-02).
 */
export function isMeaningfulClickTarget(target: EventTarget | null): boolean {
  if (!(target instanceof Element)) {
    return false;
  }

  const el = target.closest(
    "a[href], button, [role='button'], [role='link'], input[type='submit'], input[type='button']",
  );
  if (!el) {
    return false;
  }

  if (el instanceof HTMLButtonElement && el.disabled) {
    return false;
  }

  if (el instanceof HTMLInputElement && el.disabled) {
    return false;
  }

  // Exclude toggles / switch-like controls (E-01).
  if (el.getAttribute("role") === "switch" || el.getAttribute("role") === "checkbox") {
    return false;
  }

  if (el instanceof HTMLInputElement) {
    const type = (el.type || "text").toLowerCase();
    if (type === "checkbox" || type === "radio" || type === "range") {
      return false;
    }
  }

  // Soft-banner actions should not re-trigger soft show via the same click.
  if (el.closest("[data-app-update-prompt]")) {
    return false;
  }

  return true;
}
